import { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { I18nProvider } from "@/i18n";
import { ThemeProvider } from "@/context/theme";
import { ADMIN_PATH } from "@/lib/api";
import Home from "@/pages/Home";
import CuentaApp from "@/pages/cuenta/CuentaApp";
import Checkout from "@/pages/Checkout";
import Docs from "@/pages/Docs";
import ResetPassword from "@/pages/ResetPassword";
import Registro from "@/pages/Registro";

const AdminApp = lazy(() => import("@/pages/admin/AdminApp"));

const Fallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <Loader2 className="w-8 h-8 animate-spin text-primary" />
  </div>
);

function App() {
  return (
    <ThemeProvider>
      <I18nProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/cuenta/restablecer" element={<ResetPassword />} />
            <Route path="/cuenta/*" element={<CuentaApp />} />
            <Route path="/docs" element={<Docs />} />
            <Route path="/registro" element={<Registro />} />
            <Route path="/registrarse" element={<Registro />} />
            <Route path="/pagar/:slug/o/:orderId" element={<Checkout />} />
            <Route path="/pagar/:slug/:linkId" element={<Checkout />} />
            <Route
              path={`${ADMIN_PATH}/*`}
              element={
                <Suspense fallback={<Fallback />}>
                  <AdminApp />
                </Suspense>
              }
            />
          </Routes>
        </BrowserRouter>
      </I18nProvider>
    </ThemeProvider>
  );
}

export default App;
